
<template>
  <div>
    <v-card class="rounded-xl elevation-8" height="100%" width="100%">
      <!-- Top Bar -->
      <v-app-bar color="primary" dense dark flat class="rounded-t-xl">
        <v-toolbar-title class="text-h6 font-weight-medium">
          <v-icon left class="mr-2">mdi-shield-check</v-icon>
          MSP Approval
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- Content -->
      <v-card-text class="pa-0">
        <!-- Loading -->
        <v-container v-if="StartupLoadingFlag" fluid class="py-6 text-center">
          <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
        </v-container>

        <!-- Content Container -->
        <v-container fluid class="pa-6">
          <!-- Previous Remarks -->
          <v-row v-if="row.Description" class="mb-6">
            <v-col cols="12">
              <v-card outlined class="rounded-lg pa-0 previous-remarks-card">
                <v-card-title class="py-3 px-4 grey lighten-4">
                  <v-icon color="primary" size="20" class="mr-2"
                    >mdi-history</v-icon
                  >
                  <span class="text-subtitle-1 font-weight-bold primary--text"
                    >Previous Approval Remarks</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <p
                    v-html="row.DescriptionText"
                    class="ma-0 previous-remarks"
                  ></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <!-- Divider -->
      <v-divider></v-divider>

      <!-- Approval Actions -->
      <v-card-actions class="approval-actions pa-0">
        <v-container class="py-5">
          <v-row>
            <v-col cols="12">
              <h3 class="text-h6 font-weight-medium mb-4 px-4">
                <v-icon color="primary" class="mr-2">mdi-text-box-check</v-icon>
                Enter Approval Details
              </h3>
            </v-col>
          </v-row>

          <v-row class="px-3">
            <v-col cols="12">
              <v-textarea
                v-model="approvalDescription"
                outlined
                label="Approval Description"
                placeholder="Enter your comments or reasons for approval/rejection"
                rows="4"
                counter="500"
                :rules="[(v) => v.length <= 500 || 'Max 500 characters']"
                class="approval-textarea"
                hide-details="auto"
                background-color="white"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row class="px-3 mt-5">
            <v-col
              cols="12"
              class="d-flex flex-wrap justify-space-between align-center"
            >
              <div>
                <v-btn
                  color="success"
                  class="px-6 mr-3 mb-2 white--text"
                  elevation="2"
                  rounded
                  @click="submitForm(1)"
                  :loading="ApproveLoadingFlag"
                  :disabled="!approvalDescription.trim()"
                >
                  <v-icon left>mdi-check-circle</v-icon>
                  Approve
                </v-btn>

                <v-btn
                  color="red"
                  class="px-6 mr-3 mb-2 white--text"
                  elevation="2"
                  rounded
                  @click="submitForm(3)"
                  :loading="RejectLoadingFlag"
                  :disabled="!approvalDescription.trim()"
                >
                  <v-icon left>mdi-close-circle</v-icon>
                  Reject
                </v-btn>
              </div>

              <v-btn
                outlined
                color="grey darken-1"
                class="px-6 mb-2"
                rounded
                @click="closePrompt"
              >
                <v-icon left>mdi-close</v-icon>
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    showMspDialog: {
      type: Boolean,
      required: true,
    },
    row: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      recordData: [],
      ResultFlag: false,
      StartupLoadingFlag: false,
      approvalDescription: "",
      approvalDescriptionRules: [
        (v) => !!v || "Approval Description is required",
      ],
      StatusFlag: false,
      ApproveLoadingFlag: false,
      RejectLoadingFlag: false,
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        this.pageData();
      }
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", this.StatusFlag);
    },
    validate() {
      console.log("validate is called");
      var result = this.$refs.form.validate();
      console.log("result=" + result);
      if (result) {
        this.addRecordDetails();
      } else {
        console.log("some errors occured");
      }
    },
    submitForm(Status) {
      console.log("submitForm is called");

      console.log({ Status });

      var message = "";

      var tr = this.row;
      console.log({ tr });

      var yearwiseOfficeHeldId = tr.YearwiseOfficesHeldId;
      console.log({ yearwiseOfficeHeldId });

      var memberId = tr.MemberId;
      console.log({ memberId });

      var ZoneCode = tr.ZoneCode;
      console.log({ ZoneCode });

      if (
        Status > 0 &&
        yearwiseOfficeHeldId > 0 &&
        memberId > 0 &&
        ZoneCode > 0
      ) {
        switch (Status) {
          case 1:
            this.ApproveLoadingFlag = true;
            break;

          case 3:
            this.RejectLoadingFlag = true;
            break;

          default:
            break;
        }

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-training/create-msp-certificate";
        var upload = {
          UserInterface: Status,
          YearwiseOfficeHeld: yearwiseOfficeHeldId,
          Member: memberId,
          Remarks: this.approvalDescription,
          ZoneCode: ZoneCode,
          MspCertificate: tr.MspCertificateId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.StatusFlag = false;

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            switch (Status) {
              case 1:
                thisIns.ApproveLoadingFlag = false;
                break;

              case 3:
                thisIns.RejectLoadingFlag = false;
                break;

              default:
                break;
            }

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.StatusFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        if (Status == null || Status == "") {
          message = "Status is invalid. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style scoped>
#preview {
  min-height: 200vh; /* full screen center */
  background-color: #f5f6fa;
  padding: 20px;
}

.approval-actions {
  background-color: #f9fafb;
}

.previous-remarks-card {
  border-left: 4px solid var(--v-primary-base);
  transition: box-shadow 0.3s ease;
}

.previous-remarks-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.previous-remarks {
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.75);
}

.approval-textarea ::v-deep .v-input__slot {
  border-radius: 8px;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
}
</style>
